import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";


export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive:string
}



// const MENUITEMS = [
//   { state: 'dashboard', name: 'Dashboard', iconUrl:'assets/images/dashboard_white.png', type: 'link', iconUrlActive:'assets/images/dashboard_color.png'},
//   { state: 'search', name: 'Search', iconUrl:'assets/images/search_color.png', type: 'link',iconUrlActive:'assets/images/search_white.png'},
//   { state: 'message', name: 'Message', iconUrl:'assets/images/message_white.png', type: 'link',iconUrlActive:'assets/images/message_color.png'},
//   { state: 'match', name: 'My Matches', iconUrl:'assets/images/match_white.png', type: 'link',iconUrlActive:'assets/images/match_color.png'},
//   { state: 'profile', name: 'My Profile', iconUrl:'assets/images/profile_white.png', type: 'link',iconUrlActive:'assets/images/profile_color.png'},
//   { state: 'subscription', name: 'Subscription', iconUrl:'assets/images/ic_subscription.svg', type: 'link',iconUrlActive:'assets/images/ic_Subscription_fill.svg'},
//   { state: 'payment', name: 'Payment', iconUrl:'assets/images/payment_white.png', type: 'link',iconUrlActive:'assets/images/payment_color.png'},
//   { state: 'favourite', name: 'My Favorite', iconUrl:'assets/images/fav_white.png', type: 'link',iconUrlActive:'assets/images/fav_color.png'},
//   { state: 'blog', name: 'My Blogs', iconUrl:'assets/images/writing_white.png', type: 'link',iconUrlActive:'assets/images/writing_color.png'},

//      ];



@Injectable()
export class MenuItems {
  userData
  constructor(private commonService:CommonService) {
    this.userData = this.commonService.getUser();

    
  }


}
